import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Component, computed, effect, ElementRef, inject, Input, model, signal } from '@angular/core';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { BottomSheetSaveCancelComponent } from 'src/app/components/bottom-sheet-save-cancel/bottom-sheet-save-cancel.component';
import { AppstateService } from 'src/app/services/appstate.service';
import { GridService } from 'src/app/services/controls/grid.service';
import { DataService } from 'src/app/services/data.service';
import { DialogService } from 'src/app/services/dialog.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { IAuswirkungenWirtschaftsplan } from 'src/app/types/IAuswirkungenWirtschaftsplan';
import { IFreigabeDetails } from 'src/app/types/IFreigabeDetails';
import { IProjektkostenPlan } from 'src/app/types/IProjektkostenPlan';
import { IRisikenChancen } from 'src/app/types/IRisikenchancen';
import { IFreigabeViewModel } from 'src/app/types/viewmodels/freigabe.viewmodel';
import { IWirtschaftsplan } from 'src/app/types/IWirtschaftsplan';
import { BudgetFreigabeDialogComponent } from '../budget-freigabe-dialog/budget-freigabe-dialog.component';
import { CellPreparedEvent } from 'devextreme/ui/data_grid';
import { UserService } from 'src/app/services/user.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-budget-freigabe',
  // standalone: true,
  // imports: [],
  templateUrl: './budget-freigabe.component.html',
  styleUrl: './budget-freigabe.component.css'
})
export class BudgetFreigabeComponent {

  @Input()
  set projektid(id: number) {
    if (id) {
      this.appStateService.projektId.set(id);
      this.appStateService.projektInfoId.set(id);
    }
  }
  @Input()
  set baid(id: number) {
    this.appStateService.budgetantragId.set(id);
  }

  // Der Freigabe-Dialog kann ohne Plausi geöffnet werden um Den Budgetantrag auch ablehnen zu können
  public allowFreigabe = computed(() => !this.antrag()?.freigabeFinal && this.userService.IsBearbeitungPSTorPM(this.antrag()?.aktuelleBearbeitung!) ? this.allowEdit() : this.userService.HasUserAktuelleBearbeitung(this.antrag()?.aktuelleBearbeitung!));
  public isAdmin = computed(() => this.userService.userInfo()?.isAdministrator);
  public allowEdit = computed(() =>this.userService.AllowEdit(this.antrag()?.aktuelleBearbeitung!, this.antrag()?.antragstellerID!, this.antrag()?.pstID!, this.antrag()?.pmID!))
  public allowGenerateUrsachen = computed(() => !this.antrag()?.freigabeFinal && this.allowEdit());
  public isBauControlling = computed<boolean>(() => this.antrag()?.verwaltungsbereichID == 1);
  public isBBEG = computed<boolean>(() => this.antrag()?.plangebiet == "Billebogen");
  public controlHeight = computed<string>(() => this.showAuswirkungenWIP() ? 'calc((100vh - 330px - 192px - 258px))' : 'calc((100vh - 367px - 258px) / 2)');
  public controlHeightRight = computed<string>(() => this.showAuswirkungenWIP() ? 'calc((100vh - 555px) / 2)' : 'calc(100vh - 500px)');

  // erstmal dauerhaft ausgeblendet
  public showAuswirkungenWIP = computed(() => false && (this.isBauControlling() || (!this.isBauControlling() && this.isBBEG())));
  public antrag = computed(() => this.dataFreigabe().budgetantrag);
  public wirtschaftsplaene = computed<IWirtschaftsplan[] | null>(() => this.dataService.wirtschaftsplaene());
  public dataFreigabe = computed<IFreigabeViewModel>(() => this.dataService.budgetantragFreigabe());
  public dataFreigabeUrsachen = model<string>("");
  public dataFreigabePlausibilitaet = model<string>("");
  public dataAbweichungen = computed<IProjektkostenPlan[] | null>(() => this.dataService.budgetantragFreigabe()?.budgetantragDifferenzen ? this.dataService.budgetantragFreigabe()!.budgetantragDifferenzen!.filter(x => !x.isHiddenInView || (this.dataFreigabe()?.budgetantrag!.verwaltungsbereichID == 1)) : []);
  public dataRisikenChancen = computed<IRisikenChancen[] | null>(() => this.dataService.budgetantragFreigabe().risikenChancen!);
  public dataAuswirkungenWIP = computed<IAuswirkungenWirtschaftsplan[] | null>(() => this.dataService.budgetantragFreigabe().auswirkungenWirtschaftsplan!);
  public dataChanged = signal<boolean>(false);
  public dataValueChanged = signal("");

  private sheetSaveCancel?: MatBottomSheetRef<BottomSheetSaveCancelComponent>;
  public dialog = inject(MatDialog);

  constructor(public gridService: GridService,
    private dataService: DataService,
    private dialogService: DialogService,
    private appStateService: AppstateService,
    public navigationService: NavigationService,
    public userService: UserService,
    private activeRoute: ActivatedRoute,
    private elRef: ElementRef,
    private sanitizer: DomSanitizer) {

    effect(() => {
      // get data from service
      this.DataLoad();
    }, { allowSignalWrites: true });

    effect(() => {
      if (this.dataValueChanged()) {

        if (this.sheetSaveCancel && this.sheetSaveCancel.componentRef) {
          this.sheetSaveCancel!.componentRef!.instance.saveDisabled = !this.IsDataValid();
        }
      }
    });


    effect(() => {
      // changes detected
      if (this.dataChanged()) {

        this.sheetSaveCancel = this.dialogService.showSaveChangesSheet();
        var componentRef = this.sheetSaveCancel.componentRef?.instance;

        // opened
        this.sheetSaveCancel.afterOpened().subscribe(() => {
          componentRef!.saveDisabled = !this.IsDataValid();
        });

        // save clicked
        componentRef?.actionClicked.subscribe(() => {
          // POST
          var details: IFreigabeDetails = { ursachen: this.dataFreigabeUrsachen(), anmerkung: "" };
          this.dataService.updateFreigabeDetails(this.appStateService.budgetantragId()!, details).subscribe({
            next: (dataFreigabe: HttpResponse<IFreigabeViewModel>) => {
              if (dataFreigabe?.body) {
                this.dataService.budgetantragFreigabe.set(dataFreigabe.body);
              }
              this.DataSaved();
            },
            error: (err: HttpErrorResponse) => { }
          });
        });

        // cancel clicked
        this.sheetSaveCancel.afterDismissed().subscribe((data) => {
          if (data && data.action == 'Cancel') {
            // reset data
            this.DataCanceled();
          }
        });
      }
    }, { allowSignalWrites: true });

  }

  private DataLoad() {
    // copy data to model
    if (this.dataFreigabe()?.ursache) {
      this.dataFreigabeUrsachen.set(this.dataFreigabe()?.ursache!);
    }
    if (this.dataFreigabe()?.plausibilitaetText) {
      var safehtml = this.sanitizer.bypassSecurityTrustHtml(this.dataFreigabe()?.plausibilitaetText!);
      this.dataFreigabePlausibilitaet.set(safehtml as string);
    }
  }

  private DataCanceled() {
    this.DataLoad();
    this.dataChanged.set(false);
    this.dialogService.showMessageSheet('Die Änderungen an den Freigabedetails wurden verworfen');
  }

  private DataSaved() {
    this.sheetSaveCancel!.dismiss();
    this.dataChanged.set(false);
    this.dialogService.showMessageSheet('Die Freigabedetails wurden erfolgreich aktualisiert');
  }

  public DataStateChange() {
    this.dataChanged.set(true);
    this.dataValueChanged.set(Date.now().toString());
  }
  private IsDataValid(): boolean {
    var valid = (this.dataFreigabeUrsachen() != '' && this.dataFreigabePlausibilitaet() != '');
    return valid;
  }


  BackButtonClicked() {
    this.navigationService.navigateBackToBudgetantragDashboard(this.activeRoute);
  }

  CustomButtonClicked() {
    this.dialogService.showDialog('Möchten Sie die Zusammenfassung der Ursachen generieren?', 'Ursachen generieren').subscribe(result => {
      if (result == true) {
        // POST
        this.dataService.readFreigabeUrsachen(this.appStateService.budgetantragId()).subscribe((data) => {
          this.dataFreigabeUrsachen.set(data.ursachen);
          this.dataChanged.set(true);
        })
      }
    });

  }

  buttonOpenFreigabeDialog_click() {
    const dialogRef = this.dialog.open(BudgetFreigabeDialogComponent, {
      height: '700px',
      width: '900px',
      disableClose: true,
      data: { name: 'Freigabe', title: 'Freigabe' },
    });
  }

  buttonOpenAbschlussbericht_click() {
     this.dataService.getReport(this.appStateService.budgetantragId()!).subscribe(result => {
      var newWindow = window.open(result.url);
      newWindow?.document.close();
      newWindow?.focus();
    });
  }

buttonFreigabeAufheben_click() {
    this.dialogService.showDialog(`Möchten Sie die Freigabe aufheben und den Budgetantrag wieder in die Bearbeitung zurücksetzen? Der dazugehörige Budgetplan wird in der PKDB gelöscht!`, 'Freigabe aufheben', undefined, 220).subscribe(result => {
      if (result) {
        this.dataService.updateFreigabeAufheben(this.appStateService.budgetantragId()!).subscribe({
          next: (dataFreigabe: HttpResponse<IFreigabeViewModel>) => {
            if (dataFreigabe?.body) {
              this.dataService.budgetantragFreigabe.set(dataFreigabe.body);
            }
            this.dataService.refreshBudgetantragKostenUndFreigabe();
            this.dataService.refreshBudgetantragDetails();
            this.dialogService.showMessageSheet(`Die Freigabe wurde aufgehoben und der Budgetantrag ist wieder in der Bearbeitung.`);
          },
          error: (err: HttpErrorResponse) => { }
        });
      }
    })
  }


  onCellPrepared($event: CellPreparedEvent) {
    if ($event.rowType === "data") {
      if ($event.column.dataField === "rest" && $event.data.rest != 0) {
        $event.cellElement.style.cssText = "color: red;";
        $event.cellElement.style.textAlign = "end";
      }
    }
  }

  ngAfterViewInit() {
    this.elRef.nativeElement.addEventListener('click', (event: any) => {
      // Prüfen, ob der Button mit der gewünschten ID geklickt wurde
      if (event.target && event.target.classList.contains('btnHerleitung'))
        this.navigationService.navigateToBudgetantragKostenherleitungFromFreigabe(this.activeRoute);
      else if (event.target && event.target.classList.contains('btnLageplan'))
        this.navigationService.navigateToBudgetantragDetailsFromFreigabe(this.activeRoute);
      else if (event.target && event.target.classList.contains('btnZuordnung'))
        this.navigationService.navigateToBudgetantragZuordnungFromFreigabe(this.activeRoute);
 
    });
  }


}
